var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M1.333 8.5h13.334m-13.334 0A6.667 6.667 0 0 0 8 15.167M1.333 8.5A6.667 6.667 0 0 1 8 1.833M14.667 8.5A6.667 6.667 0 0 1 8 15.167M14.667 8.5A6.667 6.667 0 0 0 8 1.833m0 0A10.2 10.2 0 0 1 10.667 8.5 10.2 10.2 0 0 1 8 15.167M8 1.833A10.2 10.2 0 0 0 5.333 8.5 10.2 10.2 0 0 0 8 15.167"
  })));
};
export default SvgGlobe;